
export function setIncomeTotal(value, application) {
    
    var total=
    parseFloat(application.income.ssi) +
    parseFloat(application.income.ssdi) +
    parseFloat(application.income.tanf) +
    parseFloat(application.income.snapEBT) +
    parseFloat(application.income.mfipDwip) +
    parseFloat(application.income.employment) +
    parseFloat(application.income.unEmployment) +
    parseFloat(application.income.childSupport) +
    parseFloat(application.income.other)
    ;

    application.income.total = total;
return total;
}
